import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocationSearch, LocationSearchFilter, LocationSearchMatch } from '../location/location-search';
import { LocationSearchService } from '../location/location-search.service';

import { Message, ConfirmationService, SelectItem } from 'primeng/primeng';

@Component({
  selector: 'pl-location-search',
  templateUrl: './location-search.component.html',
  styleUrls: ['./location-search.component.css'],
  providers: [ConfirmationService]
})
export class LocationSearchComponent implements OnInit {

  locationSearchList: LocationSearch[];
  msgs: Message[];
  selectedLocationSearch: LocationSearch;
  selectedLocationSearchFilter: LocationSearchFilter;
  selectedLocationSearchMatch: LocationSearchMatch;

  comparators: SelectItem[];
  fieldsReceipt: SelectItem[];
  fieldsLocations : SelectItem[];

  constructor(private locationSearchService: LocationSearchService, private router: Router,
    private confirmationService: ConfirmationService) {
    this.locationSearchList = [];
    this.msgs = [];
    this.comparators = [];
    this.fieldsReceipt = [];
    this.fieldsLocations = [];
    this.selectedLocationSearch = this.createDefaultLocationSearch();
  }

  ngOnInit() {
    this.loadComparableFields();
    this.loadComparableLocationFields();
    this.loadComparators();
    this.loadLocationSearchs();
  }

  private loadComparableFields() {
    this.fieldsReceipt = [];
    this.fieldsReceipt.push({ value: 'receipt.receipt', label: 'WE-Nr' });
    this.fieldsReceipt.push({ value: 'receipt.hint', label: 'Lieferhinweis' });
    this.fieldsReceipt.push({ value: 'receipt.gate', label: 'Tor' });
    this.fieldsReceipt.push({ value: 'receipt.state', label: 'WE-Status' });
    this.fieldsReceipt.push({ value: 'receiptpos.pos', label: 'WE-Pos.' });
    this.fieldsReceipt.push({ value: 'receiptpos.qtyExpected', label: 'Menge Soll' });
    this.fieldsReceipt.push({ value: 'receiptpos.qtyReceived', label: 'Menge Ist' });
    this.fieldsReceipt.push({ value: 'receiptpos.reservationCode', label: 'Reservierungscode' });
    this.fieldsReceipt.push({ value: 'receiptpos.state', label: 'Pos. Status' });
    this.fieldsReceipt.push({ value: 'article.articleNumber', label: 'Artikelnr.' });
    this.fieldsReceipt.push({ value: 'article.base.unit', label: 'Basiseinheit' });
    this.fieldsReceipt.push({ value: 'article.receipt.unit', label: 'Liefereinheit' });
    this.fieldsReceipt.push({ value: 'article.receipt.baseFactor', label: 'Liefereinheitfaktor.' });
    this.fieldsReceipt.push({ value: 'article.weight', label: 'Artikel-Gewicht' });
    this.fieldsReceipt.push({ value: 'article.serialNumber', label: 'Seriennr.-KNZ' });
    this.fieldsReceipt.push({ value: 'article.charge', label: 'Charge-KNZ' });
    this.fieldsReceipt.push({ value: 'article.pickable', label: 'Kommissionierbar-KNZ' });
    this.fieldsReceipt.push({ value: 'article.name1', label: 'Artikelbez. 1' });
    this.fieldsReceipt.push({ value: 'article.name2', label: 'Artikelbez. 2' });
    this.fieldsReceipt.push({ value: 'article.name3', label: 'Artikelbez. 3' });
    this.fieldsReceipt.push({ value: 'article.name4', label: 'Artikelbez. 4' });
    this.fieldsReceipt.push({ value: 'article.descr', label: 'Artikelbeschreibung' });
    this.fieldsReceipt.push({ value: 'bintype.name', label: 'Beh. Typ. Name' });
    this.fieldsReceipt.push({ value: 'bintype.shortname', label: 'Beh.-Typ.-Kurzname' });
    this.fieldsReceipt.push({ value: 'bintype.height', label: 'Beh.-Typ.-Hoehe' });
    this.fieldsReceipt.push({ value: 'bintype.width', label: 'Beh.-Typ.-Breite' });
    this.fieldsReceipt.push({ value: 'bintype.length', label: 'Beh.-Typ.-Laenge' });
    this.fieldsReceipt.push({ value: 'bintype.weight', label: 'Beh.-Typ.-Gewicht' });
    this.fieldsReceipt.push({ value: 'bintype.relativeSize', label: 'Beh.-Typ. relative Groesse' });
    this.fieldsReceipt.push({ value: 'bin.weight', label: 'Beh. Gewicht' });
    this.fieldsReceipt.push({ value: 'bin.barcode', label: 'Beh. Barcode' });
  }

  private loadComparableLocationFields() {
    this.fieldsLocations = [];
    this.fieldsLocations.push({ value: 'area.name', label: 'Bereichsname' });
    this.fieldsLocations.push({ value: 'area.shortname', label: 'Bereichskurzname' });
    this.fieldsLocations.push({ value: 'area.prefix', label: 'Bereichsprefix' });
    this.fieldsLocations.push({ value: 'locationType.name', label: 'Platz-Typ: Name' });
    this.fieldsLocations.push({ value: 'locationType.picking', label: 'Platz-Typ: Kommissionierung' });
    this.fieldsLocations.push({ value: 'locationType.transport', label: 'Platz-Typ: Transporte' });
    this.fieldsLocations.push({ value: 'locationType.compact', label: 'Platz-Typ: Verdichten' });
    this.fieldsLocations.push({ value: 'locationType.inbound', label: 'Platz-Typ: WE-Zone' });
    this.fieldsLocations.push({ value: 'locationType.outbound', label: 'Platz-Typ: WA-Zone' });
    this.fieldsLocations.push({ value: 'locationType.count', label: 'Platz-Typ: Kapazitaet' });
    this.fieldsLocations.push({ value: 'barcode', label: 'Barcode' });
    this.fieldsLocations.push({ value: 'capacityUsed', label: 'Kapazität (belegt)' });
    this.fieldsLocations.push({ value: 'capacityFree', label: 'Kapazität (frei)' });
    this.fieldsLocations.push({ value: 'capacityMax', label: 'Kapazität (max)' });
    this.fieldsLocations.push({ value: 'loadUsed', label: 'Tragkraft (belegt)' });
    this.fieldsLocations.push({ value: 'loadFree', label: 'Tragkraft (frei)' });
    this.fieldsLocations.push({ value: 'loadMax', label: 'Tragkraft (max)' });
  }

  private loadComparators() {
    this.comparators = [];
    this.comparators.push({ value: '=', label: '=' });
    this.comparators.push({ value: '!=', label: '!=' });
    this.comparators.push({ value: '>', label: '>' });
    this.comparators.push({ value: '<', label: '<' });
    this.comparators.push({ value: '>=', label: '>=' });
    this.comparators.push({ value: '<=', label: '<=' });
    this.comparators.push({ value: 'startsWith', label: 'Beginnt mit' });
    this.comparators.push({ value: 'endsWith', label: 'Ended mit' });
    this.comparators.push({ value: 'contains', label: 'Beinhaltet' });
    this.comparators.push({ value: 'notStartsWith', label: 'Beginnt nicht mit' });
    this.comparators.push({ value: 'notEndsWith', label: 'Ended nicht mit' });
    this.comparators.push({ value: 'notContains', label: 'Beinhaltet nicht' });
  }

  private loadLocationSearchs() {
    console.log("Load LocationSearches...");
    this.locationSearchService.list().subscribe(
      (locationSearchArray: LocationSearch[]) => {
        this.locationSearchList = [];
        this.selectedLocationSearch = this.createDefaultLocationSearch();
        this.selectedLocationSearchFilter = null;
        this.selectedLocationSearchMatch = null;
        for (var locationSearch of locationSearchArray)
          this.locationSearchList = [...this.locationSearchList, locationSearch];
      },
      (err) => {
        console.log(err);
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'Error', detail: 'Could not load list of locationSearchs.' });
      }
    );
  }

  private createDefaultLocationSearch(): LocationSearch {
    let locationSearch = new LocationSearch();
    locationSearch.id = -1;

    locationSearch.descr = "";
    locationSearch.name = "";
    locationSearch.priority = 99;
    locationSearch.task = "";

    locationSearch.filters = [];
    locationSearch.matches = [];

    locationSearch.created = new Date();
    locationSearch.updated = new Date();
    return locationSearch;
  }

  public addNew() {
    console.log('Create new LocationSearch.');

    /**
     * We need to check first, if there is already a new instance
     * in list of areas.
     */
    for (var a of this.locationSearchList) {
      if (a.id < 0) {
        this.selectedLocationSearch = a;
        this.msgs.push({ severity: 'info', summary: 'Erst neuen Platz speichern.' });
        return;
      }
    }

    let locationSearch = this.createDefaultLocationSearch();

    this.locationSearchList = [...this.locationSearchList, locationSearch];
    this.selectedLocationSearch = locationSearch;
  }

  /**
   * Navigate to details component
   */
  public editSelected() {
  }

  public deleteSelected() {
    console.log("Delete location type triggered");
    this.msgs = [];
    if (this.selectedLocationSearch == null) {
      console.log("No location type selected -> return");
      this.msgs.push({ severity: 'info', summary: 'Keine Strategie ausgewaehlt.' });
      return;
    }
    this.confirmationService.confirm({
      message: 'Moechten Sie die Strategie wirlich loeschen?',
      accept: () => {
        this.locationSearchService.delete(this.selectedLocationSearch.id).subscribe(
          (success: any) => {
            if (success != null && success.success) {
              this.msgs.push({ severity: 'info', summary: 'Strategie wurde geloescht.' });
              this.loadLocationSearchs();
            } else {
              this.msgs.push({ severity: 'warn', summary: 'Strategie konnte nicht geloescht werden.' });
              console.log('Error on serverside.');
            }
          },
          (err) => {
            this.msgs.push({ severity: 'warn', summary: 'Strategie konnte nicht geloescht werden.' });
            console.log(err);
          }
        );
      }
    });

  }

  /**
   * Saves or updates edited locationSearch entity to server.
   */
  public onSave() {
    if (this.selectedLocationSearch == null || this.selectedLocationSearch.id == null)
      this.msgs.push({ severity: 'info', summary: 'Please add or selected an locationSearch first.' });

    if (this.selectedLocationSearch.id == -1) {
      this.locationSearchService.save(this.selectedLocationSearch).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Die Strategie wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.loadLocationSearchs();
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Die Strategie konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save locationSearch, error msg: ' + err);
        }
      );
    }
    else {
      this.locationSearchService.update(this.selectedLocationSearch).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Die Strategie wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.loadLocationSearchs();
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Die Strategie konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save locationSearch, error msg: ' + err);
        }
      );
    }
  }


  /**
   * Helper function to edit filters and matches
   */
  public addFilter() {
    console.log('Add filter triggered.');
    if (this.selectedLocationSearch != null) {
      let filter: LocationSearchFilter = new LocationSearchFilter();
      filter.id = 0;
      filter.comparator = '=';
      filter.field = this.fieldsLocations[0].value;
      filter.expression = '';
      filter.created = new Date();

      this.selectedLocationSearch.filters = [...this.selectedLocationSearch.filters, filter];
    } else {
      this.msgs = [];
      this.msgs.push({ summary: 'Bitte erst eine Strategie auswählen.' });
    }
  }

  public addMatch() {
    console.log('Add match triggered.');
    if (this.selectedLocationSearch != null) {
      let match: LocationSearchMatch = new LocationSearchMatch();
      match.id = 0;
      match.comparator = '=';
      match.field = this.fieldsReceipt[0].value;
      match.expression = '';
      match.created = new Date();

      this.selectedLocationSearch.matches = [...this.selectedLocationSearch.matches, match];
    } else {
      this.msgs = [];
      this.msgs.push({ summary: 'Bitte erst eine Strategie auswählen.' });
    }
  }

  public deleteSelectedFilter() {
    if (this.selectedLocationSearchFilter != null) {
      let filters: LocationSearchFilter[] = [];
      for (var filter of this.selectedLocationSearch.filters) {
        if(!this.compareFilter(filter,this.selectedLocationSearchFilter))
          filters.push(filter);
      }
      this.selectedLocationSearch.filters = filters;
    } else {
      this.msgs = [];
      this.msgs.push({ summary: 'Bitte erst einen Filter auswählen.' });
    }
  }

  public deleteSelectedMatch() {
    if (this.selectedLocationSearchMatch != null) {
      let matches: LocationSearchMatch[] = [];
      for (var match of this.selectedLocationSearch.matches) {
        if(!this.compareMatch(match,this.selectedLocationSearchMatch))
        matches.push(match);
      }
      this.selectedLocationSearch.matches = matches;
    } else {
      this.msgs = [];
      this.msgs.push({ summary: 'Bitte erst einen Filter auswählen.' });
    }
  }

  private compareFilter(o1: LocationSearchFilter, o2: LocationSearchFilter): boolean {
    if (o1.comparator === o2.comparator &&
      o1.expression === o2.expression &&
      o1.field === o2.field &&
      o1.id === o2.id) {
      return true;
    } else {
      return false;
    }
  }

  private compareMatch(o1: LocationSearchMatch, o2: LocationSearchMatch): boolean {
    if (o1.comparator === o2.comparator &&
      o1.expression === o2.expression &&
      o1.field === o2.field &&
      o1.id === o2.id) {
      return true;
    } else {
      return false;
    }
  }
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/location-search/location-search.component.ts